import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from './alertMessageSlice';
import EnterPriceService from '../services/enterprise.service';

export const getJobsListSlice = createAsyncThunk(
  'getJobsListSlice',
  async (thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const jobList = await EnterPriceService?.getJobsList(
        brandUser?.tenant_id
      );
      return jobList;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getAllReportsJobsListSlice = createAsyncThunk(
  'getAllReportsJobsListSlice',
  async (thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const jobList = await EnterPriceService?.getAllReportJobsList(
        brandUser?.tenant_id
      );
      return jobList;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getIndividualJobSlice = createAsyncThunk(
  'getIndividualJobSlice',
  async ({ job_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const jobList = await EnterPriceService?.getIndividualJobsList(
        brandUser?.tenant_id,
        job_id //replace with job id while using
      );
      return jobList;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createNewJobSlice = createAsyncThunk(
  'createNewJobSlice',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const newJobData = await EnterPriceService?.createNewJobId(
        brandUser?.tenant_id,
        body
      );
      // console.log(newJobData);
      return newJobData;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createUploadJobSlice = createAsyncThunk(
  'createUploadJobSlice',
  async ({ body, job_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const newJobData = await EnterPriceService.createNewJobUpload(
        brandUser?.tenant_id,
        job_id,
        body
      );
      return newJobData;
    } catch (error) {

      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createJobMappingSlice = createAsyncThunk(
  'createUploadJobSlice',
  async ({ body, job_id, job_file_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      // console.log(brandUser?.tenant_id, job_id, job_file_id, body);
      const newJobMap = await EnterPriceService.createJobMappings({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id,
        job_file_id: job_file_id,
        body: body,
      });
      return newJobMap;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createJobValidate = createAsyncThunk(
  'createUploadJobSlice',
  async ({ job_id, job_file_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const newJobMap = await EnterPriceService.jobValidate({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id,
        job_file_id: job_file_id,
      });
      return newJobMap;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const completeJobSlice = createAsyncThunk(
  'completeJobSlice',
  async ({ job_id, job_file_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const newJobMap = await EnterPriceService.completeJob({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id,
        job_file_id: job_file_id,
      });
      return newJobMap;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getJobDataSlice = createAsyncThunk(
  'getJobDataSlice',
  async ({ job_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const newJobMap = await EnterPriceService.getJobData({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id,
      });
      return newJobMap;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getJobMappingSlice = createAsyncThunk(
  'getJobMappingSlice',
  async ({ job_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const jobMapping = await EnterPriceService.getJobMapping({
        tenant_id: parseInt(brandUser?.tenant_id, 10),
        job_id: parseInt(job_id, 10),
      });
      return jobMapping;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getJobSummarySlice = createAsyncThunk(
  'getJobSummarySlice',
  async ({ job_id, job_file_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const jobSummary = await EnterPriceService.getJobSummary({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id,
        job_file_id: job_file_id,
      });
      return jobSummary;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getJobInsightsSlice = createAsyncThunk(
  'getJobInsightsSlice',
  async ({ body, job_id, job_file_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      // console.log(brandUser?.tenant_id, job_id, job_file_id, body);
      const insightsData = await EnterPriceService.getJobInsights({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id,
        job_file_id: job_file_id,
        body: body,
      });
      return insightsData;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const completeJobActionSlice = createAsyncThunk(
  'completeJobActionSlice',
  async ({ body, job_id, job_file_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      // console.log(brandUser?.tenant_id, job_id, job_file_id, body);
      const jobActionsSet = await EnterPriceService.completeJobAction({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id,
        job_file_id: job_file_id,
        body: body,
      });
      return jobActionsSet;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);
export const getJobActionSlice = createAsyncThunk(
  'getJobActionSlice',
  async ({ job_id, job_file_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      // console.log(brandUser?.tenant_id, job_id, job_file_id, body);
      const actionsData = await EnterPriceService.getJobActions({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id,
        job_file_id: job_file_id,
      });
      return actionsData;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const undoJobActionSlice = createAsyncThunk(
  'undoJobActionSlice',
  async ({ job_id, job_file_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      // console.log(brandUser?.tenant_id, job_id, job_file_id, body);
      const response = await EnterPriceService.undoJobActions({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id,
        job_file_id: job_file_id,
      });
      return response;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getEnterpriseReportSlice = createAsyncThunk(
  'getEnterpriseReportSlice',
  async ({ job_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      // console.log(brandUser?.tenant_id, job_id, job_file_id, body);
      const response = await EnterPriceService.enterpriseReport({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id
      });
      return response;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getEnterpriseTableSlice = createAsyncThunk(
  'getEnterpriseTableSlice',
  async ({ job_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const response = await EnterPriceService.getEnterpriseTable({
        tenant_id: brandUser?.tenant_id,
        job_id: job_id
      });
      return response;
    } catch (error) {
      // console.log(error);
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.response.data.detail ||
        error.toString();
      thunkAPI.dispatch(
        setMessage({
          message: message,
          type: 'rejected',
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);


export const enterPriseDelete = createAsyncThunk(
  'enterPriseDelete',
  async (jobId, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const response = await EnterPriceService.enterPriseDelete(
        brandUser?.tenant_id,
        jobId
      );
      thunkAPI.dispatch(getAllReportsJobsListSlice());
      thunkAPI.dispatch(setMessage('Report is deleted successfully.'));
      return { response };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);



const initialState = {
  jobsList : [],
  enterprise_report:[],
  enterprise_table_headers:[],
  enterprise_table_body:[],
  resetFlag: false,
}

// Create competitive intelligence slice
const enterpriseSlice = createSlice({
  name: 'competitiveIntelligence',
  initialState,
  reducers:{
    
    resetFlagFunc: (state, action) => {
      state.resetFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
      builder
        .addCase(getAllReportsJobsListSlice.fulfilled, (state, action) => {
          console.log(action.payload, "action.payload in enterprise");
          state.jobsList =
            action?.payload || null;

        })
        .addCase(getAllReportsJobsListSlice.rejected, (state, action) => {
          state.jobsList = [];

        })
        .addCase(getEnterpriseReportSlice.fulfilled, (state, action) => {
          console.log(action.payload, "action.payload in enterprise");
          state.enterprise_report =
            action?.payload || null;

        })
        .addCase(getEnterpriseReportSlice.rejected, (state, action) => {
          state.enterprise_report = [];

        })
        
        .addCase(getJobMappingSlice.fulfilled, (state, action) => {
          console.log(action.payload, "action.payload in enterprise");
          state.enterprise_table_headers =
            action?.payload || null;

        })
        .addCase(getJobMappingSlice.rejected, (state, action) => {
          state.enterprise_table_headers = [];

        })
        .addCase(getEnterpriseTableSlice.fulfilled, (state, action) => {
          console.log(action.payload, "action.payload in enterprise");
          state.enterprise_table_body =
            action?.payload || null;

        })
        .addCase(getEnterpriseTableSlice.rejected, (state, action) => {
          state.enterprise_table_body = [];

        })

      .addCase(enterPriseDelete.fulfilled, (state, action) => {
        // Handle successful topic fetching
        state.error = null;
      })
      .addCase(enterPriseDelete.rejected, (state, action) => {
        state.error = action.payload || 'Failed to fetch topics';
      })
        

        
      }
    });
    
    export const {
      resetFlagFunc
    } = enterpriseSlice.actions;

export default enterpriseSlice.reducer;
